export function reducer(state, action) {
  switch (action.type) {
    case "SET_ORDER_REQUEST_KEY":
      // Once Set It Cannot Be Changed
      return {
        ...state,
        orderRequestKey: state.orderRequestKey ? state.orderRequestKey : action.payload
      };
    case "SET_REQUEST_STATUS":
      return {
        ...state,
        status: action.payload
      };
    case "ADD_SUCCESS_REQUEST":
      return {
        ...state,
        requests: {
          ...state.requests,
          success: [...state.requests.success, action.payload]
        }
      };
    case "ADD_FAILED_REQUEST":
      return {
        ...state,
        requests: {
          ...state.requests,
          failed: [...state.requests.failed, action.payload]
        }
      };
    case "SET_CURRENT_REQUEST":
      return {
        ...state,
        current: action.payload
      };
    case "SET_REQUEST_ERROR":
      return {
        ...state,
        error: action.payload
      };
    default:
      console.warn("Unknown action type", action.type);
      return state;
  }
}

export default reducer;
